import React from 'react';
import { Box } from '@mui/material';
import TransferMatchingConfigForm from './components/TransferMatchingConfigForm';

const TransferMatchingConfigEditPage: React.FC = () => {
  return (
    <Box p={3}>
      <TransferMatchingConfigForm isEdit={true} />
    </Box>
  );
};

export default TransferMatchingConfigEditPage;